import { store } from "../../../../..";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import {
    selectSelectedTournament,
    tournamentManagementActions,
} from "../../../../../features/tourneymgmt/tournamentManagementSlice";
import { getTeamsByAgeLevel, getUsers } from "../../../../../lib/api";
import { isChildTournament } from "../../../../../lib/utils";

const loader = async ({ request, params }: any) => {
    const url = new URL(request.url);
    const tournamentType = url.searchParams.get("type") as
        | "child"
        | "master"
        | "either"
        | null;
    const { tournamentId } = params;

    const tournaments = store.getState().tournamentmanagement.tournaments;
    const masterTournaments =
        store.getState().tournamentmanagement.masterTournaments;
    const ageLevels = store.getState().global.ageLevels;
    const fields = store.getState().global.fields;
    const settings = store.getState().global.settings;
    const designations = store.getState().global.designations;
    const bracketTypes = store.getState().global.bracketTypes;
    const homeLeagues = store.getState().tournamentmanagement.homeLeagues;

    const tournamentsPromise = tournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getTournaments());

    const masterTournamentsPromise = masterTournaments.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getMasterTournaments());

    const ageLevelsPromise = ageLevels.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getAgeLevels());

    const fieldPromise = fields.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getFields());

    const settingsPromise = settings.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getSettings());

    const designationsPromise = designations.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getDesignations());

    const bracketsPromise = bracketTypes.length
        ? Promise.resolve()
        : store.dispatch(globalActions.getBracketTypes());

    const homeLeaguesPromise = homeLeagues.length
        ? Promise.resolve()
        : store.dispatch(tournamentManagementActions.getHomeLeagues());

    const [{ users }] = await Promise.all([
        getUsers("Tournament Director"),
        designationsPromise,
        tournamentsPromise,
        masterTournamentsPromise,
        ageLevelsPromise,
        fieldPromise,
        settingsPromise,
        homeLeaguesPromise,
        bracketsPromise,
    ]);

    tournamentId &&
        store.dispatch(
            tournamentManagementActions.setselectedTournamentId(
                parseInt(tournamentId),
            ),
        );

    const tournament = tournamentId
        ? selectSelectedTournament(store.getState())
        : undefined;

    const currentYear = selectSetting(
        store.getState(),
        "wibb_current_league_year",
    );

    const currentSeason = selectSetting(
        store.getState(),
        "wibb_current_league_season",
    );

    const parentTournament = isChildTournament(tournament)
        ? store
              .getState()
              .tournamentmanagement.masterTournaments.find(
                  t => t.id === tournament?.parent,
              )
        : undefined;

    const header = tournament
        ? isChildTournament(tournament)
            ? `${parentTournament?.name} - ${tournament.ageLevel}`
            : `${tournament.name} Master Tournament`
        : "Add Tournament";

    return {
        tournamentId,
        teams: isChildTournament(tournament)
            ? await getTeamsByAgeLevel(
                  tournament?.ageLevel as string,
                  currentYear?.setting as number,
                  currentSeason?.setting as string,
              )
            : undefined,
        header,
        users,
    };
};

export default loader;
